import lightGallery from 'lightgallery';
// Plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import lgVideo from 'lightgallery/plugins/video'

import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-video.css';

// On click backbtn prevent default if history.length is not null, is it exists the original URL from the link is used
document.getElementById("backbtn").addEventListener("click", function(e){
  if (history.length){
    e.preventDefault();
    history.back();
    return false;
  }
}
);



if (document.querySelector('#lightgallery')) {
    lightGallery(document.getElementById('lightgallery'), {
      plugins: [lgThumbnail, lgZoom, lgVideo],
      speed: 500,
      download: false,
      videojs: false,
      autoplayFirstVideo: false,
      youTubePlayerParams: {
        mute: 0,
        autoplay: 0
      }
    });
  }
  
  